import { TriangleAlertIcon } from 'lucide-react';

import { Badge } from '@nesso/ui/primitives/badge';
import { Item, ItemContent, ItemMedia, ItemTitle } from '@nesso/ui/primitives/item';

import type { ClientActivityItem } from '@/entities/session';

type Props = {
    item: ClientActivityItem;
};

export function ClientDetailsChartActivityEntry({ item }: Props) {
    const date = new Date(item.date);

    return (
        <Item variant="outline" alignment="center" role="listitem" className="p-3.75">
            <ItemMedia variant="tile">
                <span className="text-xxs leading-none font-bold uppercase">
                    {date.toLocaleString('en-US', { month: 'short' })}
                </span>
                <span className="text-base leading-none font-bold">{date.getDate()}</span>
            </ItemMedia>
            <ItemContent>
                <ItemTitle>
                    Session
                    {item.status === 'CANCELLED' ? (
                        <Badge variant="destructiveSoft">Cancelled</Badge>
                    ) : (
                        !item.hasNote && (
                            <Badge variant="warning">
                                <TriangleAlertIcon className="size-3" />
                                Missing Note
                            </Badge>
                        )
                    )}
                </ItemTitle>
            </ItemContent>
        </Item>
    );
}
